import Dialog from "dialog";
import template from "../html/dialog-config-color.html";
import css from "../css/dialog-config-color.css";

class ConfigColorDialog extends Dialog {
	static get template() {
		return template;
	}
	static get css() {
		return css;
	}
	static constructor() {
		customElements.define("fulljs-dialog-config-color", ConfigColorDialog);
	}
	constructor() {
		super();

		document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

		this.onupdatedevices_handler({detail: application.devices});

		this.show();
	}
	onupdatedevices_handler(event) {
		var devices = event.detail;
		var color = devices.colorSensor.value;

		this.textboxDeviceID.value = devices.colorSensor.id;
		this.textboxDeviceStatus.value = devices.colorSensor.status;
		this.textboxValue.value = `rgb(${color.r}, ${color.g}, ${color.b})`;
		this.textboxValue.style.color = `rgb(${color.r}, ${color.g}, ${color.b})`;

	}
	buttonClose_click(event) {
		this.close();
	}
	close() {
		super.close();
	}
}

ConfigColorDialog.constructor();

export default ConfigColorDialog;